const u = navigator.userAgent;
const n = navigator.platform;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isiPad = u.indexOf('Macintosh') != -1;
export default {
	callhandler (name,data,callback) {
		let result = '';
		if(n == 'Win32'){return false}
		if(isiOS || isiPad){
			result = window.webkit.messageHandlers[name].postMessage(data);
		}else{
			if(data){
				// 这是android提前与安卓开发人员协商好
				result = window.android[name](data);
			}else{
				window.android[name]();
			}
		}
		// 这里考虑到可能有的api有返回值,所以返回了个result
		callback && callback(result)
	},
	registerhandler (name, callback) {
		if(n == 'Win32'){return false}
		window[name] = res => {
			let data = '';
			if(res){
				data = JSON.parse(JSON.stringify(res)) 
			}
			callback && callback(data)
		}
	}
}


// WEBPACK FOOTER //
// ./src/config/client.js